import type { FormConfig } from '@workwave-tidal/core/form'
import { useState } from 'react'
import { BulkDriverFormValues } from '../types'

export function useFormConfig(drivers: uui.domain.client.rm.ExtendedDriver[]) {
  const [formConfig] = useState<FormConfig<BulkDriverFormValues>>(() => ({
    id: 'bulkDriverForm',
    initialValues: computeInitialValues(drivers),
  }))

  return formConfig
}

function computeInitialValues(
  drivers: uui.domain.client.rm.ExtendedDriver[],
): BulkDriverFormValues {
  const firstDriver = drivers[0].driver
  const allMobileFutureDaysVisibilityEquals = drivers.every(
    d => d.driver.mobileFutureDaysVisibility === firstDriver.mobileFutureDaysVisibility,
  )
  const allSummarizeFutureMobileRoute = drivers.every(
    d => d.driver.summarizeFutureMobileRoute === firstDriver.summarizeFutureMobileRoute,
  )
  const allBarcodeAttachmentAllowed = drivers.every(
    d => d.driver.barcodeAttachmentAllowed === firstDriver.barcodeAttachmentAllowed,
  )
  return {
    mobileFutureDaysVisibility: allMobileFutureDaysVisibilityEquals
      ? { status: 'exact', value: `${firstDriver.mobileFutureDaysVisibility}` }
      : { status: 'mixed' },
    summarizeFutureMobileRoute: allSummarizeFutureMobileRoute
      ? { status: 'exact', value: firstDriver.summarizeFutureMobileRoute }
      : { status: 'mixed' },
    barcodeAttachmentAllowed: allBarcodeAttachmentAllowed
      ? { status: 'exact', value: firstDriver.barcodeAttachmentAllowed }
      : { status: 'mixed' },
  }
}
